import { z } from "zod";

import { lazyModule } from "./lazy";

const libphonenumber = lazyModule(() => import("libphonenumber-js"));

export const superRefinePhoneNumber = async ({
  phoneNumber,
  ctx,
  phoneNumberFieldName = "phoneNumber",
}: {
  phoneNumber: string;
  ctx: z.RefinementCtx;
  phoneNumberFieldName?: string;
}) => {
  const { parsePhoneNumberWithError, ParseError } = await libphonenumber();

  const fullNumber = phoneNumber.startsWith("+") ? phoneNumber : `+${phoneNumber}`;
  try {
    const parsed = parsePhoneNumberWithError(fullNumber);

    if (!parsed.isValid()) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: [phoneNumberFieldName],
        message: "Invalid phone number",
      });
    }
  } catch (err) {
    let message = "Invalid phone number";

    if (err instanceof ParseError) {
      switch (err.message) {
        case "NOT_A_NUMBER":
          message = "Please enter a valid phone number";
          break;
        case "INVALID_COUNTRY":
          message = "Invalid country code";
          break;
        case "TOO_SHORT":
          message = "Phone number is too short";
          break;
        case "TOO_LONG":
          message = "Phone number is too long";
          break;
        case "INVALID_LENGTH":
          message = "Invalid phone number length";
          break;
        default:
          message = "Invalid phone number";
          break;
      }
    }
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: [phoneNumberFieldName],
      message,
    });
  }
};
